const CAREERS_CDN = 'https://neoterra-site.b-cdn.net/careers%20page';

export const careersHeroDesktop = `${CAREERS_CDN}/shot1.png`;
export const careersIntroDesktop = `${CAREERS_CDN}/shot2.png`;
export const careersWhyWorkDesktop = `${CAREERS_CDN}/shot%203.png`;
export const careersHeroMobile = `${CAREERS_CDN}/shot4.png`;
export const careersIdeasImage = `${CAREERS_CDN}/a-place-where-ideas-matter.jpeg`;
export const careersLeadersImage = `${CAREERS_CDN}/grow-with-leaders-who-inspire.jpeg`;
export const careersImpactImage = `${CAREERS_CDN}/do-work-that-makes-a-difference.jpeg`;
export const careersCultureImage = `${CAREERS_CDN}/a-culture-built-on-respect.jpeg`;
